import Flex from '@eversports/react-components/primitives/Flex'
import Skeleton from '@eversports/react-components/primitives/Skeleton'

const SkeletonRequiredInformation = () => (
  <Flex flexDirection="column" verticalSpacing="default">
    <Skeleton variant="text" height="24px" width="156px" />
    <Skeleton variant="text" height="20px" width="182px" />
    <Skeleton variant="rectangular" height="30px" />
    <Skeleton variant="rectangular" height="30px" />
    <Skeleton variant="rectangular" height="30px" />
    <Skeleton variant="rectangular" height="30px" />
  </Flex>
)

export default SkeletonRequiredInformation
